import { ReactNode } from 'react';

import { FormattedMessage } from 'react-intl';

import {
    GeneralBlockBody,
    GeneralBlockHeader,
    GeneralBlockTitle,
    GeneralBlockValue,
} from 'src/registry/components/blocks/GeneralBlock';
import { Skeleton } from 'src/registry/ui/Skeleton';

type PricingPlanDashboardGeneralBlockProps = {
    translationTitle: { id: string; defaultMessage: string };
    dataField: string | ReactNode | (() => ReactNode);
    isLoading: boolean;
};

const PricingPlanDashboardGeneralBlock = ({
    translationTitle,
    dataField,
    isLoading,
}: PricingPlanDashboardGeneralBlockProps) => (
    <div className="flex flex-1 flex-col" key={translationTitle.id}>
        <GeneralBlockHeader variant="dashboard">
            <GeneralBlockTitle>
                <FormattedMessage {...translationTitle} />
            </GeneralBlockTitle>
        </GeneralBlockHeader>
        <GeneralBlockBody variant="dashboard">
            {isLoading ? (
                <Skeleton className="h-8 w-full max-w-48" />
            ) : (
                <GeneralBlockValue size="small" className="break-words whitespace-normal">
                    {typeof dataField === 'function' ? dataField() : dataField}
                </GeneralBlockValue>
            )}
        </GeneralBlockBody>
    </div>
);

export default PricingPlanDashboardGeneralBlock;
